module.exports = __webpack_public_path__ + "static/media/andres_reggi_avatar.c97e3e00.jpg";